module.exports = __webpack_public_path__ + "static/media/Samsung Galaxy Note 5 Gold.d6a6bec5.png";